import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_GARMIN_CONNECT_WEAR_TIME_DATA_FETCH =
  "REQUEST_GARMIN_CONNECT_WEAR_TIME_DATA_FETCH";
export const doREQUEST_GARMIN_CONNECT_WEAR_TIME_DATA_FETCH = createDoRequestAction(
  REQUEST_GARMIN_CONNECT_WEAR_TIME_DATA_FETCH,
);

export const requestGarminConnectWearTimeDataFetchActionCreators = {
  doREQUEST_GARMIN_CONNECT_WEAR_TIME_DATA_FETCH,
};

export function* requestGarminConnectWearTimeDataFetch({
  payload,
  setRequestResult,
}: any): SagaIterator {
  debug("saga*requestGarminConnectWearTimeDataFetch");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        yymmddIndexList: v.array().items(v.number()),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_GARMIN_CONNECT_WEAR_TIME_DATA_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { projectId, yymmddIndexList } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/project-garmin-connect-wear-time-data-fetch`,
    accessToken,
    data: {
      projectId,
      yymmddIndexList,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_GARMIN_CONNECT_WEAR_TIME_DATA_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/project-garmin-connect-wear-time-data-fetch",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_GARMIN_CONNECT_WEAR_TIME_DATA_FETCH,
        fromPayload: payload,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* garminConnectWearTimeDataFetchSaga() {
  yield takeEvery(
    REQUEST_GARMIN_CONNECT_WEAR_TIME_DATA_FETCH,
    requestGarminConnectWearTimeDataFetch,
  );
}
